import loglevel from 'loglevel';
import Promise from 'bluebird';
import request from './cache/requestCache';
import proxy from './requestProxy';
import fallback from './cache/fallbackCache';
import Provider from 'lib/auth/Provider';

const log = loglevel.getLogger('ClientAPI');

const ONE_HOUR = 3600;

const CONFIGURATION = {
    baseUrl: 'http://api-app.espn.com',
    baseInternalUrl: 'http://sports-bc.prod.espninfra.starwave.com',
    endPoint: '/v1/watch/clients/',
    apiKey: '',
    intlProviderServiceUrl: 'http://a.espncdn.com/watchespn/feeds/intlaffmock.json' // Temporary static provider list
};

const FULL_PREAUTH_PROVIDERS = [
    'Comcast_SSO',
    'ATT',
    'Charter_Direct',
    'TWC',
    'Brighthouse',
    'Cablevision',
    'Verizon',
    'Bend',
    'WOW',
    'Suddenlink',
    'Mediacom',
    'Dish',
    'Grande',
    'HTC',
    'RCN'
];

function getServiceUrl({ platform = 'web', partner = 'watchespn' } = {}) {
    return `${CONFIGURATION.baseUrl}${CONFIGURATION.endPoint}${partner}-${platform}`;
}

function getProviderServiceUrl (platform = 'web', country = 'us') {
    return (country === 'us') ?
        `${getServiceUrl({ platform })}/providers?country=${country}` :
        CONFIGURATION.intlProviderServiceUrl;
}

function getClient({ platform = 'web' } = {}) {
    const url = `${getServiceUrl({ platform })}?enable=providers,channels`;

    log.debug(`getClient: ${url}`);

    return request(url)
        .expiration(ONE_HOUR)
        .use(proxy)
        .then(({ body }) => {
            const client = body.clients[0];
            const result = {
                channels: client.channels,
                providers: client.providers
            };

            fallback.set(url, result);
            return result;
        })
        .catch((err) => {
            log.error('getClient:', err.originalError);
            return fallback.get(url);
        });
}

function getProviders({ platform = 'web', country = 'us' } = {}) {
    const url = getProviderServiceUrl(platform, country);
    log.debug(`getProviders: ${url}`);

    // if (country === 'au') {
    //     const intlProviders = require('../../../test/mocks/intlProvider.json');
    //     return Promise.resolve(intlProviders.clients[0].providers);
    // }
    return request.get(url)
        .expiration(ONE_HOUR)
        .use(proxy)
        .then(({ body }) => {
            if (body.clients) {
                const client = body.clients[0];
                const providers = client.providers.map((provider) => (Provider.createProviderDomestic(provider)));
                fallback.set(url, providers);
                return providers;
            }
            if (body.intlaffiliates) {
                const intlProviders = body.intlaffiliates.map((affiliate) => (Provider.createProviderIntl(affiliate)));
                fallback.set(url, intlProviders);
                return intlProviders;
            }
        })
        .catch((err) => {
            log.error('getProviders:', err.originalError);
            return fallback.get(url).error(() => []);
        });
}

module.exports = {
    getClient,
    getProviders,
    FULL_PREAUTH_PROVIDERS
};



// WEBPACK FOOTER //
// ./app/lib/api/ClientAPI.js